const CapsuleBox = ({
  leadingIcon = null,
  trailingIcon = null,
  content,
  parentClass = "",
  leadingIconContentClass = "",
  onCapsuleClick,
  href = "",
}) => {
  const handleClick = (e) => {
    if (href) {
      window.open(href, "_blank", "noopener,noreferrer");
    }
    if (onCapsuleClick) {
      onCapsuleClick(e);
    }
  };

  return (
    <div className={`flex ${parentClass}`} onClick={handleClick}>
      <div className={`flex ${leadingIconContentClass}`}>
        {leadingIcon}
        {content}
      </div>
      {trailingIcon}
    </div>
  );
};

export default CapsuleBox;
